var _title, _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgStructuredIndexesIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Structured Indexes Icon")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Structured-Indexes-Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(9.000000, 8.000000)",
    fill: "#0039CB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3826087,4.70621469 C7.33331309,4.70621469 5.30869565,6.13087088 5.30869565,8.98022599 C5.30869565,10.4529264 5.78695174,11.5014093 6.74347826,12.1257062 C7.61682856,12.6957164 9.45368567,13.3858195 12.2540978,14.1960331 L13.0804348,14.430791 C16.3485671,15.3432249 18.6521672,16.4317263 19.9913043,17.6963277 C21.3304415,18.9609291 22,20.953847 22,23.6751412 C22,27.1327856 21.019575,29.7179764 19.0586957,31.430791 C17.0978163,33.1436056 14.4275531,34 11.0478261,34 C8.33766761,34 5.34059613,33.6798525 2.05652174,33.039548 L0.334782609,32.7033898 L0.860869565,28.4293785 L2.64312952,28.6587118 C6.08271047,29.082096 8.77266111,29.2937853 10.7130435,29.2937853 C14.6666864,29.2937853 16.6434783,27.5329743 16.6434783,24.0112994 C16.6434783,22.6346447 16.1971059,21.6181765 15.3043478,20.9618644 C14.4115897,20.3055523 12.4029142,19.5852205 9.27826087,18.8008475 C6.15360757,18.0164744 3.82609461,16.9359768 2.29565217,15.559322 C0.765209739,14.1826673 0,12.0056646 0,9.02824859 C0,6.05083257 0.964483109,3.80179668 2.89347826,2.28107345 C4.82247341,0.760350212 7.49273657,0 10.9043478,0 C13.1840694,0 15.8486414,0.248440961 18.8981337,0.745329803 L21.2826087,1.15254237 L20.8521739,5.47457627 L19.239532,5.29449079 C15.619686,4.90230501 13.0007327,4.70621469 11.3826087,4.70621469 Z",
    id: "SP"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "OI",
    points: "26 34 26 0 31.28 0 31.28 34"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStructuredIndexesIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Structured_Indexes_Icon.caa758c3.svg";
export { ForwardRef as ReactComponent };